import { ErrorBase } from "@util/errors";

export class BalanceAccountInactiveError extends ErrorBase {
	constructor() {
		super("Guthabenkonto ist nicht aktiv");
	}
}
